module.exports = __webpack_public_path__ + "vue-app/img/small-1.2cc97f37.jpg";